<template>
    <button class="btn-search" @click="searchMyPosition">
      <span>내 위치로 찾기</span>
    </button>
</template>

<script>
import $ from 'jquery'
import { SET_USE_KAKAO_MAP } from '@/store/_actions/actionTypes'
export default {
  methods: {
    searchMyPosition () {
      this.$store.commit(SET_USE_KAKAO_MAP, true)
      $('#searchMyPostion.cusLayer').animate({ bottom: '0' }, 400)
    }
  }
}

</script>

<style>
.btn-search {
  padding: 1rem 0;
  cursor: pointer;
  width: 100%;
  border: 1px solid var(--primary);;
  color: var(--primary);;
  font-weight: bold;
  margin-top: 0.8rem;
      display: flex;
    align-items: center;
    justify-content: center;
}

.btn-search span{
    position: relative;
    padding-left: 3rem;
}
.btn-search::before{
    background-image: url('../../assets/img/ic-gps.svg');
    content: '';
    position: absolute;
    width: 2.2rem;
    height: 2.2rem;
    background-size: 2.2rem;
    margin-left: -9rem;
}

</style>
